// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b971b70b","389":"9b84d26d","453":"9b73764c","455":"765282a6","977":"a0941936"}[chunkId] + ".chunk.js";
};